import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { ADD, GET_BY_ID } from "../../../queries/pushNotification";

const Create = (props) => {
  return (
    <Mutation
      mutation={ADD}
      update={(cache, { data: { createMessage } }) => {
        const { messages } = cache.readQuery({ query: GET_BY_ID, variables: { publisherId: localStorage.getItem('publisher-active') } });
        cache.writeQuery({
          query: GET_BY_ID,
          variables: { publisherId: localStorage.getItem('publisher-active') },
          data: { messages: messages.concat([createMessage]) }
        });
      }}
      >
      {createMessage => (
       <Form query_f = {createMessage} {...props} />
      )}
    </Mutation>
  );
};

export default Create;